<template>
  <a class="saler-item" target="_blank" :href="data.website">
    <YorkbbsImage
      class="saler-cover"
      width="100%"
      height="220px"
      borderRadius="5px 5px 0 0"
      animation
      :src="data.image | webpFormat(250)"
    ></YorkbbsImage>
    <div class="saler-desc__wrapper">
      <div class="saler-desc">
        <div class="saler-name e">{{ data.name }}</div>
        <div class="saler-introduce e-2">{{ data.description }}</div>
        <div class="saler-concat">
          <div class="saler-tel">{{ data.phone | phoneFormat }}</div>
          <YorkbbsWechatPopover placement="bottom" :weChatId="data.weChatId" :weChatQrcode="data.weChatQrCode">
            <div class="saler-wechat">
              <i class="yk-house_wechat"></i>
              <span>加微信</span>
            </div>
          </YorkbbsWechatPopover>
        </div>
      </div>
    </div>
    <img class="saler-label" :src="require('@/assets/images/car/label_saler.png')" />
  </a>
</template>
<script>
import YorkbbsWechatPopover from '@/common/popover-wechat.vue';
export default {
  name: 'ItemSaler',
  props: { data: Object },
  components: { YorkbbsWechatPopover },
};
</script>
<style lang="scss" scoped>
.saler-item {
  width: 220px;
  display: block;
  position: relative;
}
.saler-desc__wrapper {
  background: #f8f8f8;
  padding: 0 10px 10px;
}
.saler-desc {
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
  margin-top: -30px;
  position: relative;
  z-index: 2;
}
.saler-name {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  &:hover {
    color: var(--primary-color);
  }
}
.saler-introduce {
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-9);
  margin-bottom: 5px;
}
.saler-concat {
  display: flex;
  align-items: center;
}
.saler-tel {
  font-size: 14px;
  line-height: 20px;
}
.saler-wechat {
  line-height: 20px;
  margin-left: 10px;
  i {
    font-size: 12px;
    color: #4cbf00;
    margin-right: 5px;
  }
  span {
    font-size: 14px;
    color: var(--text-color-3);
  }
  &:hover {
    span {
      color: var(--primary-color);
    }
  }
}
.saler-label {
  width: 74px;
  height: 30px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>
